"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var web_utils_1 = require("@ubeeqo/web-utils");
var axios_client_service_1 = require("../../axios-client/axios-client.service");
var _decorators_1 = require("../../_decorators");
var app_const_1 = require("./app.const");
/**
 * AppService
 * Global api calls for BO application
 * @class
 */
var AppService = /** @class */ (function () {
    function AppService() {
    }
    /**
     * Retrieves a menu for user/operator combination
     * @param queryParams: Query
     * @returns Promise<Page[]>
     */
    AppService.prototype.getMenu = function (queryParams) {
        var query = web_utils_1.toQueryString(queryParams);
        var url = app_const_1.APP_ENDPOINT.menu.replace('{{query}}', query);
        return axios_client_service_1.axiosClientInstance.get(url);
    };
    tslib_1.__decorate([
        _decorators_1.snakeCaseRequest,
        tslib_1.__metadata("design:type", Function),
        tslib_1.__metadata("design:paramtypes", [Object]),
        tslib_1.__metadata("design:returntype", Promise)
    ], AppService.prototype, "getMenu", null);
    return AppService;
}());
/**
 * AppService Class Instance
 * @namespace
 */
exports.app = new AppService();
